import { SMARTMARKET_COLORS } from "../palette";
import { BRAND_FAVICONS } from "../favicons";
import { BRAND_OG_IMAGES } from "../ogImages";
import welcomeBadge from "@/images/welcome.png";
import {
  SmartMarketWordmark,
  SmartMarketStacked,
  SmartMarketMark,
  SmartMarketGlyph,
} from "../assets/smartmarket";
import type { BrandThemeConfig } from "../types";

// SmartMarket — the default brand, and the fallback when configuration is
// missing or invalid. Its spark and currency icons are the marks the app
// already used, kept as they are.
export const smartMarketTheme: BrandThemeConfig = {
  id: "smartmarket",
  label: "SmartMarket",
  colors: SMARTMARKET_COLORS,
  assets: {
    logoWordmark: SmartMarketWordmark,
    logoStacked: SmartMarketStacked,
    logoMark: SmartMarketMark,
    sparkIcon: SmartMarketGlyph,
    currencyIcon: SmartMarketGlyph,
    favicon: BRAND_FAVICONS.smartmarket,
    ogImage: BRAND_OG_IMAGES.smartmarket,
    welcomeBadge,
  },
};
